import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";

import { useStyles } from "../../../../Components/CSS/TableStyle.css";
import AdminHeader from "../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import CustomTableHead from "../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import CustomTableFooter from "../../../../Components/Table/CutomTableFooter/CustomTableFooter";
import PageTitle from "../../../../Components/PageTitle/PageTitle";
import SubjectFilter from "../SubjectFilter/SubjectFilter";
import CustomSiteLoader from "../../../../Components/CustomSiteLoader/CustomSiteLoader";
import CustomEmptyMessage from "../../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import Axios from "axios";
import { url } from "../../../../Config/Config";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import SubjectBody from "../SubjectBody/SubjectBody";
import AddSubject from "../AddSubject/AddSubject";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";
import CustomBreadCrumbs from "../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class ViewSubject extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowsPerPage: 10,
      page: 0,
      search: {
        subjectName: "",
      },
      isEmpty: false,
      detailStatus: false,
      detailData: [],
      column: [{ name: "S.N." }, { name: "Subject Name" }, { name: "Actions" }],
      subjects: [],
    };
  }

  componentDidMount() {
    this.getSubjects();
  }

  getSubjects = async () => {
    try {
      const response = await Axios.get(`${url}/api/subjects`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.subjects.length !== 0) {
        this.setState({
          subjects: response.data.subjects,
          isEmpty: false,
        });
      } else {
        this.setState({
          subjects: [],
          isEmpty: true,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getSubjects();
      }
    }
  };

  handleDetailStatus = (detailData) => {
    this.setState({
      detailStatus: true,
      detailData,
    });
  };

  handleCancelDetail = () => {
    this.setState({
      detailStatus: false,
    });
  };

  handleSearch = (e) => {
    this.setState({
      search: {
        ...this.state.search,
        [e.target.name]: e.target.value,
      },
    });
  };

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  render() {
    const { classes } = this.props;
    const { rowsPerPage, page } = this.state;
    const filtered = this.state.subjects.filter((subject) => {
      return (
        subject.name
          .toLowerCase()
          .indexOf(this.state.search.subjectName.toLowerCase()) !== -1
      );
    });
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle
            title="School Subjects"
            refreshUrl={this.props.match.url}
          />

          <AddSubject getSubjects={this.getSubjects} />
          <br />
          {this.state.subjects.length !== 0 && (
            <SubjectFilter
              data={this.state.search}
              handleSearch={this.handleSearch}
            />
          )}
          <div style={{ fontSize: 20, fontWeight: "bold" }}>Subject List</div>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
              {this.state.subjects.length !== 0 ? (
                <Paper>
                  <TableContainer>
                    <Table>
                      <CustomTableHead column={this.state.column} />

                      <TableBody>
                        {(rowsPerPage > 0
                          ? filtered.slice(
                              rowsPerPage * page,
                              rowsPerPage * page + rowsPerPage
                            )
                          : filtered
                        ).map((subject, index) => (
                          <SubjectBody
                            data={subject}
                            key={index}
                            index={index}
                            handleDetailStatus={this.handleDetailStatus}
                            getSubjects={this.getSubjects}
                          />
                        ))}
                      </TableBody>

                      <CustomTableFooter
                        count={filtered.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onChangePage={this.handlePage}
                        onChangeRowsPerPage={this.handleRowsPerPage}
                      />
                    </Table>
                  </TableContainer>
                </Paper>
              ) : this.state.isEmpty ? (
                <CustomEmptyMessage />
              ) : (
                <CustomSiteLoader />
              )}
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(ViewSubject)));
